const PASSWORD_WORDS = [
	"bill-board",
	"Bio-metric",
	"Birth-days",
	"blond-ness",
	"bould-ered",
	"Cab-riole",
	"cabin-etry",
	"Cap-tioned",
	"Cap-sizing",
	"carre-four",
	"Cine-matic",
	"Civic-ally",
	"claim-able",
	"Coin-cided",
	"daili-ness",
	"Dance-hall",
	"Day-cation",
	"Date-lines",
	"Decade-ncy",
	"decla-ring",
	"Declaim-er",
	"Deco-rates",
	"decret-ory",
	"delici-ous",
	"delive-red",
	"Digit-ally",
	"ecom-merce",
	"econo-mies",
	"easter-nly",
	"econo-mize",
	"elong-ated",
	"elevat-ors",
	"emers-ions",
	"factor-ise",
	"Facul-ties",
	"faith-fuls",
	"Fantas-tic",
	"final-ised",
	"finan-cier",
	"finger-tip",
	"fount-ains",
	"free-lance",
	"fresh-ener",
	"fre-quency",
	"fresh-ened",
	"Furn-ished",
	"gain-fully",
	"gem-stone",
	"Gener-ally",
	"geo-metric",
	"geo-logist",
	"give-aways",
	"glori-fied",
	"grati-tude",
	"guide-line",
	"habit-ancy",
	"hail-stone",
	"hair-brush",
	"hair-dryer",
	"hand-write",
	"Heal-thier",
	"house-hold",
	"house-tops",
	"honey-comb",
	"honey-bees",
	"Idea-listic",
	"ideo-logic",
	"ideo-graph",
	"Impro-vise",
	"Incre-ment",
	"Includ-ing",
	"jelly-fish",
	"jet-liners",
	"job-holder",
	"key-boards",
	"kilo-grams",
	"knock-outs",
	"know-ledge",
	"lake-front",
	"light-room",
	"Magne-tics",
	"meni-festo",
	"mani-folds",
	"maxi-mised",
	"neck-piece",
	"neigh-bors",
	"nego-tiate",
	"nick-names",
	"news-board",
	"Nota-tions",
	"note-books",
	"obvious-ly",
	"Occa-sions",
	"obtur-ated",
	"ossu-pants",
	"Onloo-king",
	"Opera-tive",
	"outer-coat",
	"out-shines",
	"over-flows",
	"owner-ship",
	"pass-books",
	"pass-enger",
	"pay-checks",
];
export default PASSWORD_WORDS;